"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CURRENCY = void 0;
exports.DEFAULT_CURRENCY = 'EUR';
